// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"part-block_wrapper__2_CWB","inner":"part-block_inner__3uUT3"};